module.exports = __webpack_public_path__ + "static/media/shveden.61a5f5f5.png";